import React, { useContext, useEffect, useState } from 'react';
import { Typography } from '@pw-tech/omni-ui';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import Image from 'next/image';
import useIsMobile from '@/hooks/useIsMobile';
import { CourseContext } from '@/modules/RegisterLayout/contexts/CoursesContextProvider';
const SemesterFee = () => {
  const {
    registrationDetails
  } = useContext(RegistrationContext);
  const {
    selectedCourseData
  } = useContext(CourseContext);
  const isMobileScreen = useIsMobile();
  return <article data-sentry-component="SemesterFee" data-sentry-source-file="index.tsx">
      <div className="flex flex-col gap-5">
        <Typography variant="regular" className="bg-[#FFF6E5] md:!items-center flex gap-2 p-4 rounded-lg" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {isMobileScreen ? <div className="flex gap-2 ">
              <Image src="/images/registerPage/trophy.png" alt="trophy-icon" className="!h-8 !w-8 rounded-full" width={28} height={28} />
              <div className="flex">
                <p className="font-semibold">
                  Heads up, future innovator -
                  <span className="font-normal">
                    {' '}
                    you’re selected for {registrationDetails?.campusAlloted || ''} 2026 for{' '}
                    {selectedCourseData?.name || ''}
                  </span>
                </p>
              </div>
            </div> : <>
              <div className="">
                <Image src="/images/registerPage/trophy.png" alt="trophy-icon" className="items-start rounded-full" width={28} height={28} />
              </div>
              <div className="flex">
                <p className="font-semibold">
                  Heads up, future innovator -
                  <span className="font-normal">
                    {' '}
                    you’re selected for {registrationDetails?.campusAlloted || ''} 2026 for{' '}
                    {selectedCourseData?.name || ''}
                  </span>
                </p>
              </div>
            </>}
        </Typography>
        <Typography variant="heading3" weight="semi-bold" className="!text-2xl" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          Next Step: Payment of First Semester Fees
        </Typography>
        <div className="shadow-[0px_8px_24px_0px_rgba(0,0,0,0.06)] p-4 text-[#757575]">
          <div className="flex flex-col gap-y-8">
            <Typography variant="regular" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              As you begin this exciting journey with us, the next step is to complete the payment
              of your first semester fees. Detailed instructions and payment links will be shared
              with you within the next 2–5 business days.
            </Typography>
            <Typography variant="regular" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              Once again, congratulations on becoming part of PW IOI! We look forward to supporting
              you in achieving your academic and professional goals.
            </Typography>
          </div>
        </div>
      </div>
    </article>;
};
export default SemesterFee;